import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// utils

// ----------------------------------------------------------------------

type PromotionsManagementState = {
  featuredList: unknown[];
  newMerchantList: unknown[];
  recommendationList: unknown[];
};

const initialState: PromotionsManagementState = {
  featuredList: [],
  newMerchantList: [],
  recommendationList: []
};

const slice = createSlice({
  name: 'promotions-management',
  initialState,
  reducers: {
    setFeaturedList(state: PromotionsManagementState, action: PayloadAction<unknown[]>) {
      state.featuredList = action.payload;
    },

    setNewMerchantList(state: PromotionsManagementState, action: PayloadAction<unknown[]>) {
      state.newMerchantList = action.payload;
    },

    setRecommentdationList(state: PromotionsManagementState, action: PayloadAction<unknown[]>) {
      state.recommendationList = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;
export const { setFeaturedList, setNewMerchantList, setRecommentdationList } = slice.actions;
